import axios from "axios";

export default async function getEventAreas(access_token, eventId) {
  const resp = await axios.get(
    `${process.env.REACT_APP_ORGANISER_API}/staff-pass/config/get/${eventId}`,
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!resp.data) {
    throw new Error("Some error occured");
  }
  if (resp.data.error) {
    throw new Error(resp.data.error);
  }

  return resp.data;
}
